import Box from '@mui/material/Box';

type Props = {
  visible?: boolean;
};
export default function Dot({ visible }: Props) {
  return (
    <Box
      component="span"
      sx={{ color: 'success.main', visibility: visible ? 'visible' : 'hidden' }}
    >
      &bull;
    </Box>
  );
}
